import columns from '../../../../../react-table/helpers/columns';
import { sumTotal } from '../../../../../react-table/helpers/rowTotals';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';

export function getDetailsTabNavOptions(rowInfo) {
  return rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.INTERCHANGE_PROCESSING_DETAILS.id,
    mainReportId: ReportDefinitions.INTERCHANGE_PROCESSING_SUMMARY.id,
    requestParams: {
      senderId: rowInfo.row.sendingMailbox,
      receiverId: rowInfo.row.receivingMailbox,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
  } : {};
}

export default (data) => {
  const {
    TextColumn,
    DateColumn,
    NonZeroNumberColumn,
    NavigationColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Sender', 'sender'),
        new TextColumn('Receiver', 'receiver'),
        new TextColumn('Sending mailbox', 'sendingMailbox'),
        new TextColumn('Receiving mailbox', 'receivingMailbox'),
        new DateColumn('On network date', 'onNetworkDate').withTotalHeader('Total'),
        new NavigationColumn(new NonZeroNumberColumn('Interchanges', 'interchanges').withTotalHeader(sumTotal), getDetailsTabNavOptions),
        new NonZeroNumberColumn('On hold', 'onHold').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Pending translation', 'pendingTranslation').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Accepted', 'accepted').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Translated', 'translated').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Translation rejected', 'translationRejected').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Not loaded', 'notLoaded').withTotalHeader(sumTotal),
        new NonZeroNumberColumn('Missing', 'missing').withTotalHeader(sumTotal),
      ],
    },
  ];
};
